import { useState } from "react";

const STATUS_META = {
  AWAITING_INTAKE: { label: "Awaiting intake", tone: "slate" },
  INTAKE_SUBMITTED: { label: "Intake received", tone: "amber" },
  READY_FOR_GENERATION: { label: "Ready to generate", tone: "amber" },
  GENERATION_FAILED: { label: "Generation failed", tone: "red" },
  AWAITING_ALIAS_QA: { label: "Alias QA", tone: "amber" },
  ALIAS_CHANGES_REQUIRED: { label: "Changes required", tone: "red" },
  APPROVED_FOR_CLIENT_REVIEW: { label: "With client", tone: "blue" },
  CLIENT_CHANGES_REQUESTED: { label: "Client changes", tone: "blue" },
  READY_FOR_REVISION: { label: "Ready to revise", tone: "amber" },
  CLIENT_APPROVED: { label: "Approved · ready to publish", tone: "green" },
};

const TONES = {
  slate: "bg-slate-700/40 text-slate-200 ring-slate-500/30",
  amber: "bg-amber-500/15 text-amber-300 ring-amber-500/30",
  blue: "bg-sky-500/15 text-sky-300 ring-sky-500/30",
  green: "bg-emerald-500/15 text-emerald-300 ring-emerald-500/30",
  red: "bg-rose-500/15 text-rose-300 ring-rose-500/30",
};

export function StatusPill({ status, live, reverify }) {
  const m = live ? { label: "Live · Completed", tone: "green" }
    : reverify ? { label: "Approved · re-verification needed", tone: "amber" }
    : STATUS_META[status] || { label: status, tone: "slate" };
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ring-1 ${TONES[m.tone]}`}
    >
      {m.label}
    </span>
  );
}

export function CopyField({ label, value, testid }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(value); } catch (_) {}
    setDone(true);
    setTimeout(() => setDone(false), 1600);
  };
  return (
    <div className="rounded-xl bg-slate-900/60 ring-1 ring-slate-700/60 p-3">
      {label && <p className="text-[11px] uppercase tracking-wide text-slate-400 mb-1.5">{label}</p>}
      <div className="flex items-center gap-2">
        <input
          readOnly
          value={value}
          data-testid={`${testid}-value`}
          className="flex-1 min-w-0 bg-transparent text-sm text-slate-200 outline-none truncate"
          onFocus={(e) => e.target.select()}
        />
        <button
          onClick={copy}
          data-testid={`${testid}-copy`}
          className="shrink-0 rounded-lg bg-amber-500 px-3 py-1.5 text-xs font-semibold text-slate-950 hover:bg-amber-400 transition-colors"
        >
          {done ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}

// TEST-078: a temporary storage/API problem is never shown as "Job not found" or an endless "Loading…".
export function LoadError({ err, onRetry, onBack }) {
  const missing = err && err.status === 404;
  return (
    <div className="min-h-screen bg-slate-950 text-slate-300 grid place-items-center px-4" data-testid="load-error">
      <div className="max-w-sm text-center space-y-4">
        <p className="text-base font-medium text-slate-100" data-testid="load-error-title">
          {missing ? "Job not found" : "This job couldn't be loaded right now"}
        </p>
        <p className="text-sm text-slate-400" data-testid="load-error-message">
          {missing ? "Check the job link or go back to the jobs list." : (err && err.message) || "Please try again in a moment."}
        </p>
        <div className="flex justify-center gap-2">
          {!missing && (
            <button onClick={onRetry} data-testid="load-error-retry" className="rounded-lg px-4 py-2 text-sm bg-amber-500 text-slate-950 font-medium hover:bg-amber-400 transition-colors">
              Try again
            </button>
          )}
          <button onClick={onBack} data-testid="load-error-back" className="rounded-lg px-4 py-2 text-sm ring-1 ring-slate-700 hover:bg-slate-800/60 transition-colors">
            Back to jobs
          </button>
        </div>
      </div>
    </div>
  );
}
